import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { products } from '@/mocks/products';

export default function ProductDetailPage() {
  const { slug } = useParams();
  const product = products.find((p) => p.slug === slug);

  useEffect(() => {
    document.title = product ? `${product.name} | NORTHLINE Flow Systems` : 'Product not found | NORTHLINE';
  }, [product]);

  return (
    <>
      <Navbar />
      <main className="bg-background-50 pt-16 md:pt-20">
        <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-12 py-12 md:py-20">
          <nav aria-label="Breadcrumb" className="font-label text-xs tracking-[0.08em] text-foreground-500">
            <Link to="/" className="cursor-pointer hover:text-primary-500">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/products" className="cursor-pointer hover:text-primary-500">Products</Link>
            {product && <><span className="mx-2">/</span><span className="text-foreground-950">{product.name}</span></>}
          </nav>
          {product ? (
            <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div className="r-img w-full aspect-square bg-background-100/60 flex items-center justify-center p-10">
                <img src={product.image} alt={`${product.name} - ${product.family}`} title={`${product.name} - NORTHLINE`} className="max-w-full max-h-full object-contain" />
              </div>
              <div>
                <Link to={`/products?category=${encodeURIComponent(product.family)}`} className="font-label text-xs tracking-[0.12em] uppercase text-primary-500 cursor-pointer">{product.family}</Link>
                <h1 data-mo="title" data-mo-now className="mt-4 h-section text-foreground-950">{product.name}</h1>
                <p data-mo="fade" data-mo-now className="mt-5 t-body text-foreground-600 max-w-md">{product.description}</p>
                <p className="mt-3 text-sm text-foreground-500 max-w-md">Specifications and availability are confirmed with each quotation.</p>
                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <Link to={`/request-quote?product=${product.slug}`} className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-label text-xs tracking-[0.1em] uppercase px-6 py-3.5 rounded-md cursor-pointer whitespace-nowrap transition-colors">Request a Quote <i className="ri-arrow-right-line" /></Link>
                  <Link to="/products" className="inline-flex items-center justify-center gap-2 border border-background-300 text-foreground-950 font-label text-xs tracking-[0.1em] uppercase px-6 py-3.5 rounded-md cursor-pointer whitespace-nowrap hover:border-foreground-950 transition-colors"><i className="ri-arrow-left-line" /> Back to catalog</Link>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-16 text-center">
              <h1 className="h-section text-foreground-950">Product not found.</h1>
              <Link to="/products" className="mt-8 inline-flex items-center gap-2 text-sm text-foreground-950 hover:text-primary-500 cursor-pointer">Back to catalog <i className="ri-arrow-right-line" /></Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}